export default __webpack_public_path__ + "static/media/veryFullBucket.29411de3.png";